<template>
  <v-btn
    v-bind:to="{ name: 'contact-qna' }"
    v-bind:class="computedButtonClass"
    v-bind:style="computedButtonStyle"
  >
    <v-img :src="imageSrc" />
    <p>{{ $t('HomePage.floating.inquiry') }}</p>
  </v-btn>
</template>

<script>
export default {
  name: 'InquiryButton',
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    buttonStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    imageSrc() {
      return require('@/assets/float_inquiry.png');
    },
    isWebtoonViewer() {
      return this.$route && this.$route.path.startsWith('/webtoon/viewer');
    },
    computedButtonClass() {
      const baseClass = this.buttonClass || '';
      const routeClass = this.isWebtoonViewer ? 'inquiry-button--webtoon' : 'inquiry-button--default';
      return `${baseClass} ${routeClass}`.trim();
    },
    computedButtonStyle() {
      return this.buttonStyle || {};
    },
  },
};
</script>

<style scoped>
/* 기본 스타일 (홈 등 일반 페이지) */
.inquiry-button--default {
  display: flex;
  flex-direction: column;
  width: 100px;
  height: 120px !important;
  border-radius: 10px;
  background-color: #343434 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;
}

.inquiry-button--default:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}

.inquiry-button--default .v-btn__content {
  flex-direction: column;
  gap: 10px;
  padding: 15px;
}

.inquiry-button--default p {
  font-size: 14px;
  color: #fff;
  margin: 0;
  text-align: center;
}

.inquiry-button--default .v-image {
  width: 40px;
  height: 40px;
}

/* 웹툰 뷰어 스타일 */
.inquiry-button--webtoon {
  display: flex;
  flex-direction: column;
  width: 80px;
  height: 80px !important;
  border-radius: 50%;
  background-color: rgba(52, 52, 52, 0.9) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;
  border: 2px solid rgba(255, 255, 255, 0.1);
}

.inquiry-button--webtoon:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.6);
  background-color: rgba(52, 52, 52, 1) !important;
}

.inquiry-button--webtoon .v-btn__content {
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  justify-content: center;
  align-items: center;
}

.inquiry-button--webtoon p {
  font-size: 11px;
  color: #fff;
  margin: 0;
  text-align: center;
  font-weight: 500;
}

.inquiry-button--webtoon .v-image {
  width: 32px;
  height: 32px;
}

/* 모바일 반응형 */
@media (max-width: 768px) {
  .inquiry-button--default {
    width: 70px;
    height: 90px !important;
  }

  .inquiry-button--default .v-btn__content {
    padding: 10px;
    gap: 8px;
  }

  .inquiry-button--default .v-image {
    width: 30px;
    height: 30px;
  }

  .inquiry-button--default p {
    font-size: 11px;
  }

  .inquiry-button--webtoon {
    width: 60px;
    height: 60px !important;
  }

  .inquiry-button--webtoon .v-btn__content {
    padding: 8px;
    gap: 4px;
  }

  .inquiry-button--webtoon .v-image {
    width: 24px;
    height: 24px;
  }

  .inquiry-button--webtoon p {
    font-size: 9px;
  }
}
</style>

